import { isSite } from '../store/basic-params/basic-params-selectors';
import { type AppState } from '../types';

export const isCreatePostButtonVisible = (
  state: AppState,
  canSee: (action: string, entity: string) => boolean,
) => isSite(state) && canSee('create', 'post');
